import { getRouteApi } from '@tanstack/react-router';
import { useScopes } from '~/components/Providers/AuthProvider';
import TableWithThumbnails, {
    PacksTableWithThumbnails,
} from '~/components/TableWithThumbnails';
import TabSwitch from '~/partials/TabSwitch';
import { TabsContent } from '~/primitives/tabs';

const Route = getRouteApi('/profile/user/$userid');

function ProfileMain() {
    const { hasScope } = useScopes();
    const { profile, total } = Route.useLoaderData({
        select: ({ profile, total }) => ({ profile, total }),
    });

    const tab = Route.useSearch({ select: ({ tab }) => tab });
    const navigate = Route.useNavigate();

    const showData = profile.ban_level <= 2 || hasScope(undefined);
    const records = showData
        ? profile.records.filter((record) => record.level.status != 'Removed')
        : [];
    const created = profile.created.filter(
        (level) => level.status != 'Removed',
    );
    const packs = showData ? profile.packs : [];

    return (
        <section className="w-full p-2 lg:px-8 lg:w-4/6 text-justify">
            <TabSwitch
                onChange={(tab) => {
                    navigate({
                        search: (prev) => ({
                            ...prev,
                            tab,
                        }),
                        replace: true,
                    });
                }}
                current={tab}
                options={['completed', 'created', 'packs']}
                optionsDisplay={[
                    `Completed (${showData ? total : 0})`,
                    `Created (${created?.length ?? 0})`,
                    `Packs (${packs?.length})`,
                ]}
                size="sm"
            >
                <TabsContent
                    value="completed"
                    className="w-full h-[calc(100vh-240px)]"
                >
                    {records.length > 0 ? (
                        <TableWithThumbnails
                            height="100%"
                            showPoints={profile?.ban_level == 0}
                            showMobile
                            showCompletionLink
                            showUserRole
                            enableSearch
                            enableSort
                            data={records}
                        />
                    ) : (
                        <p className="my-6 italic opacity-50 text-center">
                            This player does not have any records.
                        </p>
                    )}
                </TabsContent>
                <TabsContent
                    value="created"
                    className="w-full h-[calc(100vh-240px)]"
                >
                    {created.length > 0 ? (
                        <TableWithThumbnails
                            height="100%"
                            data={created}
                            showUserRole
                            enableSearch
                        />
                    ) : (
                        <p className="my-6 italic opacity-50 text-center">
                            This player has not created any Extreme Demons.
                        </p>
                    )}
                </TabsContent>
                <TabsContent
                    value="packs"
                    className="w-full h-[calc(100vh-240px)]"
                >
                    {packs.length > 0 ? (
                        <PacksTableWithThumbnails
                            height="100%"
                            data={packs}
                            showPoints={profile?.ban_level == 0}
                            enableSearch
                        />
                    ) : (
                        <p className="my-6 italic opacity-50 text-center">
                            This player has not completed any packs.
                        </p>
                    )}
                </TabsContent>
            </TabSwitch>
        </section>
    );
}

export default ProfileMain;
